/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ProblemBlobNotFound } from './ProblemBlobNotFound';
import { ProblemNotFound } from './ProblemNotFound';
import { ProblemPathNotFound } from './ProblemPathNotFound';
import { ProblemResourceNotFound } from './ProblemResourceNotFound';
import { ProblemResourceRevisionNotFound } from './ProblemResourceRevisionNotFound';

export const NotFoundProblems: core.serialization.Schema<serializers.NotFoundProblems.Raw, Truvity.NotFoundProblems> =
    core.serialization
        .union('type', {
            '/not-found': ProblemNotFound,
            '/not-found/blob': ProblemBlobNotFound,
            '/not-found/path': ProblemPathNotFound,
            '/not-found/resource': ProblemResourceNotFound,
            '/not-found/resource/revision': ProblemResourceRevisionNotFound,
        })
        .transform<Truvity.NotFoundProblems>({
            transform: (value) => value,
            untransform: (value) => value,
        });

export declare namespace NotFoundProblems {
    export type Raw =
        | NotFoundProblems.NotFound
        | NotFoundProblems.NotFoundBlob
        | NotFoundProblems.NotFoundPath
        | NotFoundProblems.NotFoundResource
        | NotFoundProblems.NotFoundResourceRevision;

    export interface NotFound extends ProblemNotFound.Raw {
        type: '/not-found';
    }

    export interface NotFoundBlob extends ProblemBlobNotFound.Raw {
        type: '/not-found/blob';
    }

    export interface NotFoundPath extends ProblemPathNotFound.Raw {
        type: '/not-found/path';
    }

    export interface NotFoundResource extends ProblemResourceNotFound.Raw {
        type: '/not-found/resource';
    }

    export interface NotFoundResourceRevision extends ProblemResourceRevisionNotFound.Raw {
        type: '/not-found/resource/revision';
    }
}
